import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  StaysWidget,
  StaysWidgetForm
} from '../../stays-widget/models/stays-widget.interfaces';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {
  setPassengerError(
    form: FormGroup<StaysWidgetForm>,
    content: StaysWidget,
    mismatchKey: string
  ): string {
    const hasError = form.hasError(mismatchKey);
    if (hasError && mismatchKey === 'staysRoomMismatch') {
      form.controls.numberOfTravelers.setErrors({ staysRoomMismatch: true });
    } else {
      form.controls.numberOfTravelers.setErrors(null);
    }
    return hasError ? content.labels.tooFewPeopleErrorLabel : '';
  }

  setRoomsError(
    form: FormGroup<StaysWidgetForm>,
    content: StaysWidget,
    mismatchKey: string
  ): string {
    const hasError = form.hasError(mismatchKey);
    if (hasError && mismatchKey === 'staysRoomTravelerMismatch') {
      form.controls.numberOfRooms.setErrors({
        staysRoomTravelerMismatch: true
      });
    } else {
      form.controls.numberOfRooms.setErrors(null);
    }
    return hasError ? content.labels.tooFewRoomsErrorLabel : '';
  }
}
